var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar__wrapper"},_vm._l((_vm.sidebarComponentSettings),function(setting){return _c(setting.component,{key:setting.id,tag:"component",class:setting.className})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }